export default __webpack_public_path__ + "static/inline-message.light-74323f9b2ff3f3aacc20ce6053381ead308d22e59b4193af1c8a32defc0d1c65.png";